import styled from '@emotion/styled';
import LegadoTermometer from 'src/containers/legado/LegadoTermometer';
import { screenSizes } from 'src/assets/styles/Literals';
import { useLocation } from 'react-router-dom';

const PostDonationContainer = styled.div`
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 130px 0 100px;

  * {
    font-family: 'Geist', sans-serif !important;
  }

  .container {
    margin-top: 60px;
    max-width: 700px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4rem;
  }

  .top-section {
    position: relative;
    height: 300px;
  }

  .text-content {
    flex: 1;
    position: absolute;
    top: 0;
    left: 0;
  }

  .thank-you {
    color: #1e3a8a;
    font-size: 1.125rem;
    margin: 0 0 1rem 0;
    font-weight: 400;
  }

  .main-title {
    color: #1e3a8a;
    font-size: 60px;
    font-weight: 700;
    line-height: 1.1;
    margin: 0;
    text-transform: uppercase;
    width: 405px;
  }

  .chair-graphic {
    position: absolute;
    top: -30px;
    right: 0;
    background: url('https://comunidadmde.s3.us-east-1.amazonaws.com/resources/legado/silla_desvanecida_azul.png')
      no-repeat center;
    background-size: contain;
    width: 400px;
    height: 375px;
  }

  @media (max-width: 1050px) {
    padding: 0 130px 0 55px;
    .container {
      margin-top: 90px;
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    .container {
      gap: 0rem;
      margin-top: 100px;
    }

    .top-section {
      flex-direction: column;
      text-align: center;
    }

    .main-title {
      font-size: 2rem;
      width: 100%;
    }

    .chair-graphic {
      width: 300px;
      height: 300px;
    }
  }

  @media (max-width: ${screenSizes.mobile}) {
    padding: 0;
  }
`;

const LegadoPostDonation = (props) => {
  const { progress, milestones, title } = props;
  const location = useLocation();

  return (
    <PostDonationContainer>
      <div className="container">
        {location.pathname !== '/legado-total-iglesia-landing' && (
          <div className="top-section">
            <div className="text-content">
              <p className="thank-you">
                Gracias por{' '}
                {location.pathname === '/legado-total-iglesia'
                  ? ' tus donaciones.'
                  : ' tu donación.'}
              </p>
              <h1 className="main-title">ERES PARTE DE ALGO MÁS GRANDE</h1>
            </div>
            <div className="chair-graphic"></div>
          </div>
        )}
        <LegadoTermometer progress={progress} title={title} milestones={milestones} />
      </div>
    </PostDonationContainer>
  );
};

export default LegadoPostDonation;
